import React from 'react';
import { Box, styled, TableCell, TableRow } from '@material-ui/core';
import { format } from 'date-fns';

import { decodePercentU } from '../utils';
import { useStyles } from '../common';
import Button from 'src/components/NewButton';
import useNotification from 'src/hooks/useNotification';

export const EpisodeRowContainer = styled(TableRow)(() => ({
  '&:hover': {
    opacity: 0.8,
  },
}));
export const CellContent = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
}));

interface EpisodeRowProps {
  buttonSpan: number;
  data: { [x: string]: any };
  handleScore: (episodeId: string) => void;
  scoringList: string[];
}

const UnscoredEpisodeRow = ({
  data,
  buttonSpan,
  handleScore,
  scoringList,
}: EpisodeRowProps) => {
  const classes = useStyles();
  const { handleSuccessWithLink } = useNotification();

  let publishedAt = null;

  if (data['Episode Date']) {
    try {
      publishedAt = format(new Date(data['Episode Date']), 'MM/dd/yyyy');
    } catch {
      publishedAt = '-';
    }
  } else {
    publishedAt = '-';
  }

  return (
    <EpisodeRowContainer
      style={{
        borderColor: '#E1E1E1',
      }}
    >
      <TableCell
        style={{
          width: '350px',
          minWidth: '320px',
          color: '#000',
          padding: '10px',
          fontSize: '16px',
          borderRight: '1px solid #E1E1E1',
        }}
        className={classes.tableFont}
      >
        <CellContent>{decodePercentU(data['Episode Title'])}</CellContent>
      </TableCell>
      <TableCell
        style={{
          width: '120px',
          minWidth: '120px',
          color: '#000',
          padding: '10px',
          fontSize: '16px',
        }}
        align='center'
        className={classes.tableFont}
      >
        <CellContent>{publishedAt}</CellContent>
      </TableCell>
      <TableCell
        style={{
          color: '#000',
          padding: '10px 20px',
        }}
        align='left'
        className={classes.scoreCell}
        colSpan={buttonSpan}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            columnGap: 12,
          }}
        >
          {data.status === 'failed' && (
            <span style={{ color: '#B42318', fontSize: 13, fontWeight: 500 }}>
              Scoring failed
            </span>
          )}
          <Button
            height={32}
            onClick={() => {
              handleScore(data.id);
              handleSuccessWithLink(
                'Episode submitted for scoring, please view status',
                'here',
                '/settings/self-scoring'
              );
            }}
            disabled={scoringList.includes(data.id) || data.status === 'queued'}
          >
            {scoringList.includes(data.id) || data.status === 'queued'
              ? 'Scoring...'
              : data.status === 'failed'
              ? 'Retry'
              : 'Score'}
          </Button>
        </div>
      </TableCell>
    </EpisodeRowContainer>
  );
};

export default UnscoredEpisodeRow;
